export class NovoCliente {
    nome: string = ''
    email: string = ''
    senha: string = ''
    confirmacao: string = ''
}